var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLoadingPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8EDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 10.8969 6.99653 10 8.22222 10H17.1111C18.3368 10 19.3333 10.8969 19.3333 12V20C19.3333 21.1031 18.3368 22 17.1111 22H8.22222C6.99653 22 6 21.1031 6 20V12ZM25.4132 11.1188C25.7743 11.2938 26 11.6312 26 12V20C26 20.3688 25.7743 20.7063 25.4132 20.8813C25.0521 21.0563 24.6146 21.0375 24.2708 20.8313L20.9375 18.8313L20.4444 18.5344V18V14V13.4656L20.9375 13.1687L24.2708 11.1688C24.6111 10.9656 25.0486 10.9438 25.4132 11.1188V11.1188Z",
    fill: "#989B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLoadingPlaceholder);
export default __webpack_public_path__ + "static/media/videoLoadingPlaceholder.17100349a068939dd7b559670d9ddc36.svg";
export { ForwardRef as ReactComponent };